import { types, actions } from './requests'
export const GETPAGEDJOBLIST_TYPES = {
    ...types('GETPAGEDJOBLIST'),
}
export const GETPAGEDJOBLIST_ACTIONS = {
    ...actions('GETPAGEDJOBLIST'),
}
